import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isNewRelicEnabled, setNewRelicRouteName } from "../utils/newrelic";

const NewRelicRouteTracker = () => {
    const location = useLocation();

    useEffect(() => {
        if (!isNewRelicEnabled()) {
            return;
        }

        setNewRelicRouteName(location.pathname);
    }, [location.pathname]);

    return null;
};

export default NewRelicRouteTracker;
